import { CreateModule, EditModule } from "./modules";

export default { Create: CreateModule, Edit: EditModule };
